// ============================================
// Prerender signal — tells scripts/prerender.mjs "this page is ready
// to be captured" during the build. No-op in production runtime
// (no listener is attached outside of the prerender Puppeteer session).
//
// Why two requestAnimationFrames? React commits the DOM synchronously
// before the first RAF; the second RAF gives the browser a paint cycle.
// Without this, Puppeteer can capture a half-mounted tree (visible as
// missing body content in dist/<route>/index.html).
//
// `ready` param defaults to true for sync pages (LandingPage, legal
// pages) that have no async data. Pages that need to wait on a fetch
// (e.g. PublicFaqSharePage waiting on the get-shared-faq edge fn)
// should pass `!loading && !!data` so the signal fires once the
// content is in the DOM + Helmet has set per-route tags.
// ============================================

import { useEffect } from 'react';

export function usePrerenderSignal(ready: boolean = true): void {
  useEffect(() => {
    if (!ready) return;
    if (typeof document === 'undefined') return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        try {
          document.dispatchEvent(new Event('render-event'));
        } catch {
          // No-op. The prerender script's renderAfterTime ceiling
          // covers this case.
        }
      });
    });
  }, [ready]);
}
